import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import AppContext from "../../../AppContext";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import PanelLayout from "../../../layouts/PanelLayout";

function MisRecibos() {
  const { empleado } = useContext(AuthEmpleadoContext);
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!empleado) return;

    axios
      .get(
        `${AppContext.baseApiUrl}/cst-servicios/recibos/empleado/${empleado.cuit}`,
      )
      .then((res) => setRecibos(res.data))
      .catch(() => alert("Error cargando recibos"))
      .finally(() => setLoading(false));
  }, [empleado]);

const descargar = async (recibo) => {
  try {
    const response = await axios.get(
      `${AppContext.baseApiUrl}/cst-servicios/recibos/descargar/${recibo.idReciboSueldo}`,
      {
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);
    const nombreArchivo = `recibo-${recibo.periodo || recibo.idReciboSueldo}.pdf`;

    const link = document.createElement("a");
    link.href = url;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error descargando recibo:", error);
    alert("No se pudo descargar el recibo.");
  }
};

  return (
    <PanelLayout>
      <div className="container my-5">
        <div className="card shadow border-0">
          <div className="card-header bg-success text-white">
            <h5 className="mb-0">📄 Mis Recibos de Sueldo</h5>
          </div>

          <div className="card-body">
            {loading && (
              <div className="text-center text-muted">Cargando recibos...</div>
            )}

            {!loading && recibos.length === 0 && (
              <div className="alert alert-info text-center">
                No hay recibos disponibles
              </div>
            )}

            {!loading && recibos.length > 0 && (
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>📅 Período</th>
                      <th>📁 Archivo</th>
                      <th className="text-end">⬇️ Descargar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recibos.map((r) => (
                      <tr key={r.idReciboSueldo}>
                        <td>{r.periodo}</td>
                        <td className="text-muted small"></td>
                        <td className="text-end">
                          <button
                            className="btn btn-outline-success btn-sm"
                            onClick={() => descargar(r)}
                          >
                            Descargar PDF
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </PanelLayout>
  );
}
export default MisRecibos;
